import React, {Component} from 'react';
import {FadeIn} from 'animate-components';

const exp_data = [
   {
      'status': 'Part-time',
      'role': 'Software Developer',
      'name': 'Open Data Kosovo',
      'type': 'Organization',
      'year': '2017'
   }, {
      'status': '',
      'role': 'Trainer/Developer',
      'name': 'Techstitution Training',
      'type': 'Training Project',
      'year': '2017'
   }, {
      'status': '',
      'role': 'Software Developer',
      'name': 'Techstitution Program',
      'type': '',
      'year': '2017'
   }, {
      'status': '',
      'role': 'Former Quality Assurance Developer',
      'name': 'EDUonGo',
      'type': 'Company',
      'year': '2016'
   }, {
      'status': '',
      'role': 'Former Intructional Designer',
      'name': 'ALMOOC',
      'type': 'Company',
      'year': '2015'
   }
]

class Experience extends Component {
   render() {
      return (
         <div ref="experience" className="main">
            <FadeIn duration="1.2s" timingFunction="ease-out">
               <div className="row">
                  <div className="col-md-3">
                     <h3 className="about-title">Employment</h3>
                  </div>
                  <div className="col-md-9">
                     { exp_data.map((data, index) => {
                        const {status, year, role, name} = data;
                        return (
                           <div key={index} className="card-container">
                              <p className="company-name">{name}</p>
                              <p>{role}</p>
                              <p>
                                 <span className="badge badge-pill badge-success">{status}</span>
                              </p>
                              <p>Year: {year}</p>
                           </div>
                        )
                     }) }
                  </div>
               </div>
            </FadeIn>
         </div>
      );
   }
}

export default Experience;



// WEBPACK FOOTER //
// ./src/components/Experience.js